import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import Table from '../../common/Table';

import { showModal } from '../../../actions/modal';
import { fetchGetUsersSearch, fetchDeleteUser } from '../../../actions/settings';

import { parseError } from '../../../helpers';

import { USERS_SETTINGS_COUNT_ON_PAGE } from '../../../config';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const getUserFullName = ({ firstName, middleName, lastName }) => {
  let name = '';

  if (firstName) name += firstName;
  if (middleName) name += ` ${middleName}`;
  if (lastName) name += ` ${lastName}`;

  return name;
};

const UsersTable = (props) => {
  const { users, roles, actualizeData, setUsers } = props;

  const dispatch = useDispatch();
  const [search, setSearch] = useState('');

  const { t } = useAutoTranslation();

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const fetchUsersList = async (data = {}) => {
    const result = await dispatch(
      fetchGetUsersSearch({ ...data, size: USERS_SETTINGS_COUNT_ON_PAGE }),
    );
    setUsers(result.users);
  };

  useEffect(() => {
    (async function () {
      const resObj = {};
      if (search) {
        resObj.codeSearch = search;
      }
      await fetchUsersList(resObj);
    })();
  }, [search]);

  const handleNewUser = () => {
    dispatch(
      showModal('EditUser', {
        roles,
        users,
        submitCallback: actualizeData,
      }),
    );
  };

  const handleEditUser = (currentUser) => {
    dispatch(
      showModal('EditUser', {
        currentUser,
        roles,
        users,
        submitCallback: actualizeData,
      }),
    );
  };

  const handleDeleteUser = (user) => {
    dispatch(
      showModal('Confirm', {
        body: `${t('Подтвердите удаление пользователя')} "${user.login}"`,

        handleConfirm: async () => {
          await dispatch(fetchDeleteUser(user.login)).catch((err) => {
            toast.error(parseError(err));
            throw err;
          });

          await actualizeData();
          toast.info(t('Пользователь успешно удален'));
        },

        confirmBtnTitle: t('Удалить'),
      }),
    );
  };

  const data = {
    cols: [t('Имя'), t('Логин'), t('Роль')],
    rows: users
      .filter((u) => !u.login.includes('_callcenter') && !u.login.includes('-expert')) // TODO Remove
      .map((u) => ({
        key: u.login,
        item: u,
        data: [
          {
            value: getUserFullName(u),
            editItem: true,
          },
          { value: u.login },
          { value: u.roles.map((r) => r.name).join(', ') },
        ],
        isRemovable: !u.isSystemUser,
      })),
  };

  return (
    <Table
      id="users"
      className="mt-2"
      data={data}
      searchable
      searchPlaceholder={t('Поиск: имя, логин, роль')}
      creatable
      createLabel={t('Новый пользователь')}
      removable
      pagination
      perPage={USERS_SETTINGS_COUNT_ON_PAGE}
      handleSearch={handleSearch}
      handleNewItem={handleNewUser}
      handleEditItem={handleEditUser}
      handleRemoveItem={handleDeleteUser}
    />
  );
};

export default UsersTable;
